namespace TabAurous.ProductDevelopment {
    export interface PDQuotationItemsRow {
        TransItemId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        RefNo?: string;
        Iteration?: string;
        ProductId?: number;
        AttributeId?: number;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        Discount?: number;
        DiscountPer?: number;
        GrossAmount?: number;
        RefTransItemId?: number;
        ExportPieces?: number;
        FancyCharges?: number;
        StatusId?: number;
        OtherCharges?: number;
        RefTransId?: number;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        AckStatus?: number;
        DeliveryDate?: string;
        CompanyId?: number;
        BagStatus?: string;
        WstPer?: number;
        WstWt?: number;
        Purity?: number;
        PureWeight?: number;
        ServerDate?: string;
        Remarks?: string;
        IsDisabled?: boolean;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        ImageName?: string;
        Image1?: string;
        Image2?: string;
        Image3?: string;
        Video1?: string;
        Video2?: string;
        CalcOnId?: number;
        LedgerName?: string;
        PartyCode?: string;
        DeptName?: string;
        ProductCode?: string;
        ProductName?: string;
        TaxCode?: string;
        CostMethodId?: number;
        SalesCostMethodId?: Common.CostMethod;
        PurchaseCostMethodId?: Common.CostMethod;
        HSN?: string;
        MetalId?: number;
        HasBom?: boolean;
        DesignId?: number;
        DesignCode?: string;
        BOMDetails?: PDQuotationBOMRow[];
        LaborDetails?: PDQuotationLaborRow[];
        AdditionalCharges?: PDQuotationAdditionalChargesRow[];
        ItemTypeId?: number;
        ItemType?: string;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        CollectionId?: number;
        MetalColorId?: number;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        CalcUnitId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        Rate?: number;
        KaratId?: number;
        ProductSizeId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        ProductSizeCode?: string;
        MetalColorCode?: string;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Lab?: string;
        VoucherNo?: string;
        TransDate?: string;
        HUID?: string;
        DesignName?: string;
        StampId?: number;
        MFAmount?: number;
        MF?: number;
        StoneRate?: number;
        OtherRate?: number;
        AdditionalAmount?: number;
    }

    export namespace PDQuotationItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'ProductName';
        export const localTextPrefix = 'ProductDevelopment.PDQuotationItems';
        export const deletePermission = 'PD:Quotation:Delete';
        export const insertPermission = 'PD:Quotation:Add';
        export const readPermission = '*';
        export const updatePermission = 'PD:Quotation:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            PartyId = "PartyId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            RefNo = "RefNo",
            Iteration = "Iteration",
            ProductId = "ProductId",
            AttributeId = "AttributeId",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            UnitRate = "UnitRate",
            UnitLabour = "UnitLabour",
            UnitCost = "UnitCost",
            NetAmount = "NetAmount",
            Discount = "Discount",
            DiscountPer = "DiscountPer",
            GrossAmount = "GrossAmount",
            RefTransItemId = "RefTransItemId",
            ExportPieces = "ExportPieces",
            FancyCharges = "FancyCharges",
            StatusId = "StatusId",
            OtherCharges = "OtherCharges",
            RefTransId = "RefTransId",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            AckStatus = "AckStatus",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            BagStatus = "BagStatus",
            WstPer = "WstPer",
            WstWt = "WstWt",
            Purity = "Purity",
            PureWeight = "PureWeight",
            ServerDate = "ServerDate",
            Remarks = "Remarks",
            IsDisabled = "IsDisabled",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            ImageName = "ImageName",
            Image1 = "Image1",
            Image2 = "Image2",
            Image3 = "Image3",
            Video1 = "Video1",
            Video2 = "Video2",
            CalcOnId = "CalcOnId",
            LedgerName = "LedgerName",
            PartyCode = "PartyCode",
            DeptName = "DeptName",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            TaxCode = "TaxCode",
            CostMethodId = "CostMethodId",
            SalesCostMethodId = "SalesCostMethodId",
            PurchaseCostMethodId = "PurchaseCostMethodId",
            HSN = "HSN",
            MetalId = "MetalId",
            HasBom = "HasBom",
            DesignId = "DesignId",
            DesignCode = "DesignCode",
            BOMDetails = "BOMDetails",
            LaborDetails = "LaborDetails",
            AdditionalCharges = "AdditionalCharges",
            ItemTypeId = "ItemTypeId",
            ItemType = "ItemType",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            CollectionId = "CollectionId",
            MetalColorId = "MetalColorId",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            CalcUnitId = "CalcUnitId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            Rate = "Rate",
            KaratId = "KaratId",
            ProductSizeId = "ProductSizeId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            ProductSizeCode = "ProductSizeCode",
            MetalColorCode = "MetalColorCode",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Lab = "Lab",
            VoucherNo = "VoucherNo",
            TransDate = "TransDate",
            HUID = "HUID",
            DesignName = "DesignName",
            StampId = "StampId",
            MFAmount = "MFAmount",
            MF = "MF",
            StoneRate = "StoneRate",
            OtherRate = "OtherRate",
            AdditionalAmount = "AdditionalAmount"
        }
    }
}
